import styled from '@emotion/styled';
import React from 'react';
import { typography } from '../../../styles/typography';

const Host = styled.div`
  ${typography.body}
`;

interface IProps {
  children: React.ReactNode;
}

export function FormDescription({ children }: IProps) {
  return <Host>{children}</Host>;
}
